module.exports = __webpack_public_path__ + "img/DOTA-BT1718999.aade09e2.png";